/**
 * @generated SignedSource<<16e7a77dd97bd3148d085a3ce9b81f21>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ShareContentUsageInput = {
  body: string;
  contentUsageId: string;
  subject: string;
};
export type ShareContentUsageFormMutation$variables = {
  input: ShareContentUsageInput;
};
export type ShareContentUsageFormMutation$data = {
  readonly response: {
    readonly errors: ReadonlyArray<{
      readonly field: string;
      readonly message: string;
    }> | null;
  };
};
export type ShareContentUsageFormMutation = {
  response: ShareContentUsageFormMutation$data;
  variables: ShareContentUsageFormMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": "response",
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ShareContentUsageResponse",
    "kind": "LinkedField",
    "name": "shareContentUsage",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ValidationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "field",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ShareContentUsageFormMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ShareContentUsageFormMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "2f5256aa9b588f879ee9ea030ba8d828",
    "id": null,
    "metadata": {},
    "name": "ShareContentUsageFormMutation",
    "operationKind": "mutation",
    "text": "mutation ShareContentUsageFormMutation(\n  $input: ShareContentUsageInput!\n) {\n  response: shareContentUsage(input: $input) {\n    errors {\n      field\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "61c17ed69754100f063f9519dcae5189";

export default node;
